import { Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthStore } from '../data-access/data-access-authentication/+state/auth.store';
import { TRole } from '../data-access/data-access-authentication/enums/role.enum';

@Directive({
  selector: '[authRole]',
})
export class RoleDirective implements OnInit {
  private readonly el = inject(TemplateRef);

  authRole = input<TRole[] | undefined>();

  private viewContainer = inject(ViewContainerRef);
  private authStore = inject(AuthStore);

  ngOnInit() {
    const roles = this.authRole();
    const currentRole = this.authStore.data()?.role;

    if (!roles?.length || (currentRole && roles.includes(currentRole))) {
      this.viewContainer.createEmbeddedView(this.el);
    } else {
      this.viewContainer.clear();
    }
  }
}
